import { Injectable } from '@angular/core';
import { WebApiService } from './web-api.service';
import { map, Observable } from 'rxjs';
import { CourtReservation } from '../model/court-reservation';
@Injectable({
  providedIn: 'root'
})
export class CourtReservationService {
  private apiUrl = 'CourtReservation'; // Replace with your API URL
  constructor(private http: WebApiService) { }

  getCourtReservations(courtId: number, date: string): Observable<any[]> {
    return this.http.get(`${this.apiUrl}/${courtId}/${date}`);
  }

  getReservationsForClub(clubId: number, date: string): Observable<any[]> {
    return this.http.get(`${this.apiUrl}/ForClub/${clubId}/${date}`);
  }

  getReservationsForClubDateRange(
    clubId: number,
    startDate: string,
    endDate: string,
    status: string
  ): Observable<any[]> {
    return this.http.get(
      `${this.apiUrl}/ForClubDateRange/${clubId}/${startDate}/${endDate}/${status}`
    );
  }

  getCourtReservationsForUser(
    userId: number,
    startDate: Date,
    endDate: Date
  ): Observable<any[]> {
    const start = startDate.toISOString().split('T')[0];
    const end = endDate.toISOString().split('T')[0];
    return this.http.get(`${this.apiUrl}/ForUser/${userId}/${start}/${end}`);
  }

  addCourtReservation(courtReservation: CourtReservation) {
    return this.http.post(`${this.apiUrl}`, courtReservation)
      .pipe(map((result: CourtReservation) => {
        return result;
      }));
  }

  updateCourtReservation(reservation: any) {
    return this.http.put(`${this.apiUrl}`, reservation);
  }

  deleteCourtReservation(id: number) {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  reserveSequence(reservations: any[]) {
    return this.http.post(`${this.apiUrl}/reserveSequence`, reservations);
  }

  addPlayerToReservation(
    userId: number,
    startDate: string,
    endDate: string,
    playerId: number
  ) {
    return this.http.put(
      `${this.apiUrl}/ForUser/${userId}/${startDate}/${endDate}/Players/${playerId}`,
      {}
    );
  }

  removePlayerFromReservation(
    userId: number,
    startDate: string,
    endDate: string,
    playerId: number
  ) {
    return this.http.delete(
      `${this.apiUrl}/ForUser/${userId}/${startDate}/${endDate}/Players/${playerId}`
    );
  }

  getFixedReservationsForClub(clubId: number) {
    return this.http.get(`${this.apiUrl}/FixedReservationsForClub/${clubId}`);
  }

  getFixedReservationsForUser(userId: number, clubId?: number) {
    const url = clubId
      ? `${this.apiUrl}/FixedReservationsForUser/${userId}/${clubId}`
      : `${this.apiUrl}/FixedReservationsForUser/${userId}`;
    return this.http.get(url);
  }

  deleteFixedSeries(fixedSeriesId: string) {
    return this.http.delete(
      `${this.apiUrl}/deleteFixedSeries/${fixedSeriesId}`
    );
  }
}
